export default "__VITE_ASSET__6824e803__"